import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    boxShadow: 24,
    p: 4,
};

interface ModalProps {
    open: boolean;
    handleClose: () => void;
    children?: React.ReactNode;
    title?: string;
    callback?: () => void;
}

const BasicModal: React.FC<ModalProps> = ({ open, handleClose, title = '', children }) => {
    // const handleCallback = () => {
    //     if (callback) {
    //         callback();
    //     }
    // };
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    {title}
                </Typography>
                {children}
            </Box>
        </Modal>
    );
};

export default BasicModal;
